import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-option-suffix',
  template: ` <ng-content></ng-content>`,
  styles: [],
})
export class OptionSuffixComponent {}
